<template>
  <MobileContainer>
    <MobileHeader slot="header"
                  nav-action="home"
                  show-logout-btn>
      My Profile
    </MobileHeader>
    <UserAccount />

    <MobileButton slot="footer"
                  :class="$style.editProfileBtn"
                  :to="{ name: 'edit-user-profile' }"
                  square
    >
      Edit Profile
    </MobileButton>
  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import MobileButton from '@/apps/mobile/components/MobileButton';
import UserAccount from '@/components/UserAccount';

/**
 * Mobile user account.
 */
@Component({
  components: {
    MobileButton,
    MobileHeader,
    MobileContainer,
    UserAccount,
  },
})
export default class MobileUserAccount extends Vue {}
</script>

<style lang="scss" module>
.editProfileBtn {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileUserAccount.vue